import { createContext } from "react";

export const ThemeContext = createContext(null);
export const LangContext = createContext(null);
export const MenuContext = createContext(false);
